import { ErrorType } from 'data/types'

import { PaymentMethodsActionType } from './actions'
import * as AT from './actionTypes'
import { PaymentMethodType } from './types'

export type CurrencyPaymentMethodsStateType = {
  readonly data: PaymentMethodType[]
  readonly error?: ErrorType
  readonly loading: boolean
}

const INITIAL_STATE = {
  data: [],
  error: undefined,
  loading: false
}

const currencyMethodReducer = (state: CurrencyPaymentMethodsStateType = INITIAL_STATE, action) => {
  if (!action) return state
  switch (action.type) {
    case AT.SET_PAYMENT_METHODS_TYPE:
      return {
        ...state,
        data: action.payload.methods
      }
    case AT.SET_PAYMENT_METHODS_LOADING_TYPE:
      return {
        ...state,
        loading: action.payload.loading
      }
    case AT.SET_PAYMENT_METHODS_ERROR_TYPE:
      return {
        ...state,
        error: action.payload.error
      }
    default:
      return state
  }
  return state
}

export type PaymentMethodsStateType = {
  [currency: string]: CurrencyPaymentMethodsStateType
}

const methodsReducer = (state: PaymentMethodsStateType = {}, action: PaymentMethodsActionType) => {
  if (!action) return state
  const { currency } = action.payload
  return {
    ...state,
    [currency]: currencyMethodReducer(state[currency], action)
  }
}

export default methodsReducer
